import React from 'react';

// Helper icon for the dropdown visual (you can replace with an SVG or a library icon)
const ChevronDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="tw-w-4 tw-h-4 tw-ml-1">
    <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
  </svg>
);

function FilterStatusBar({ dimensionBounds, currentRanges, onOpenFilterPanel }) {
  const dimensions = [
    { key: 'gallons', label: 'Gallons', unit: ' Gal' }, // Unit for when range is displayed
    { key: 'length', label: 'Length', unit: '" L' },
    { key: 'width', label: 'Width', unit: '" W' },
    { key: 'height', label: 'Height', unit: '" H' },
  ];

  const getButtonText = (dimConfig) => {
    const bounds = dimensionBounds[dimConfig.key];
    const current = currentRanges[dimConfig.key];

    if (!bounds || !current) return dimConfig.label; // Fallback

    const isSet = current.min > bounds.min || current.max < bounds.max;

    if (isSet) {
      if (dimConfig.key === 'gallons') {
        return `${current.min}-${current.max}${dimConfig.unit}`;
      }
      return `${current.min}-${current.max}${dimConfig.unit}`;
    } else {
      return dimConfig.label;
    }
  };

  const isFilterSet = (dimKey) => {
    const bounds = dimensionBounds[dimKey];
    const current = currentRanges[dimKey];
    if (!bounds || !current) return false;
    return current.min > bounds.min || current.max < bounds.max;
  };

  const baseButtonStyle = "tw-flex tw-items-center tw-justify-center tw-px-2.5 tw-py-2 tw-text-sm tw-border tw-rounded-md focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-opacity-50 tw-transition-colors tw-duration-150";
  const activeButtonStyle = "tw-bg-brand-red tw-text-white tw-border-brand-red focus:tw-ring-brand-red";
  const inactiveButtonStyle = "tw-bg-white hover:tw-bg-gray-50 tw-text-gray-700 tw-border-gray-300 focus:tw-ring-brand-red";

  // Check if all underlying data is ready
  if (Object.values(dimensionBounds).some(b => b.min === 0 && b.max === 0 && !(b.min === 0 && b.max ===0)) && 
      Object.values(currentRanges).some(r => r.min === 0 && r.max === 0 && !(r.min === 0 && r.max ===0)) ) {
    // Optional: render placeholder or disabled state
  }

  return (
    <div className="tw-flex tw-items-center tw-justify-center tw-py-3 tw-px-1 sm:tw-px-2 tw-bg-gray-100 tw-border-y tw-border-gray-200 tw-mb-4 tw-sticky tw-top-[109px] tw-z-5">
      <div className="tw-flex tw-flex-wrap tw-gap-2 sm:tw-gap-3">
        {dimensions.map((dim) => {
          const isSet = isFilterSet(dim.key);
          return (
            <button
              key={dim.key}
              onClick={onOpenFilterPanel}
              className={`${baseButtonStyle} ${isSet ? activeButtonStyle : inactiveButtonStyle}`}
            >
              {getButtonText(dim)}
              <ChevronDownIcon />
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default FilterStatusBar; 